module.exports = __webpack_public_path__ + "img/ZH.21de302f.png";